<script setup lang="ts">
import PhoneItem from "@/components/PhoneItem/PhoneItem.vue";
import {useAboutStore} from "@/stores/aboutStore";

const aboutStore = useAboutStore();
</script>
<template>
  <div class="border-bw-grey text-primary-darkBlue">
    <div class="pt-12 pb-28 flex flex-col align-center">
      <div class="container flex flex-col justify-center text-center py-12">
        <div class="responsive-title-2 font-bold mb-4">Imprint</div>
      </div>
      <div class="container w-100 space-y-6">
        <div class="responsive-body-medium text-left">
          <p class="font-bold">Cosmos Luxury Yachts P.C.</p>
          <p class="responsive-body-medium mt-4">
            7, Ave Eleftherias<br />
            17455 Athens / Alimos<br />
            Greece
          </p>
          <div class="flex items-start responsive-body-medium mt-6">
            <span class="font-bold">Phone: </span>
            <div class="flex flex-col gap-1 text-primary-darkTeal">
              <div v-for="contact in aboutStore.contactInfo" :key="contact.country">
                <PhoneItem :contact="contact"/>
              </div>
            </div>
          </div>
          <p class="responsive-body-medium mt-2">
            <span class="font-bold">Email:</span>
            <a href="mailto:info@cosmosluxuryyachts.com" class="text-primary-darkTeal hover:underline ml-2"> info@cosmosluxuryyachts.com</a>
          </p>
          <p class="responsive-body-medium mt-2">
            <span class=" font-bold">Internet:</span>
            <a href="https://cosmosluxuryyachts.com" target="_blank" rel="noopener noreferrer" class="text-primary-darkTeal hover:underline ml-2">https://cosmosluxuryyachts.com</a>
          </p>

          <p class="responsive-body-medium mt-6">
            <span class=" font-bold">Authorized representative: </span> Nikolaos Moysidis
          </p>
          <p class="responsive-body-medium mt-2">
            <span class=" font-bold">Register number: </span> (EUID): ELGEMI.170548601000
          </p>
          <p class="responsive-body-medium mt-2">
            <span class=" font-bold">Sales tax identification number: </span> EL802129677
          </p>
          <p class="responsive-body-medium mt-6">
            <span class=" font-bold">Notice of liability: </span> Despite careful content control, we assume no liability for the content of external links. The operators of the linked pages are solely responsible for their content.
          </p>
          
        </div>
      </div>
    </div>
  </div>
</template>
